export default __webpack_public_path__ + "static/media/Brigand's Leggings of Woven Clouds.5e32d395.jpg";